import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import pendingMarket from '../../../../../../assets/images/pending 2.png';
import Add from '../../../../../../assets/images/Souvenir/add .png';
import Unsold from '../../../../../../assets/images/Souvenir/packages.png';

const SuperstarMarketPlaceNav = () => {
    const [approvedCount, setApprovedCount] = useState('');
    const [pendingCount, setPendingCount] = useState('');
    
    useEffect(() => {


          axios.get(`/api/star/marketplace/product-list/approved`).then(res => {

            if(res.data.status === 200)
            {
                setApprovedCount(res.data.approvedCount);
            }
          });


          axios.get(`/api/star/marketplace/product-list/pending`).then(res => {
            if(res.data.status === 200)
            {
              setPendingCount(res.data.pendingCount);
            }
          });
    
    }, []);

    const location = useLocation();
    //   /superstar/product-list/pending
    //   /superstar/product-list/approved

    
    return (
        <>
            <div className="mb-3 row">

                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={pendingMarket} width="75px" className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold Sigma">{pendingCount}</small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        {
                            location.pathname === '/superstar/product-list/pending' ?
                            <Link to={{pathname: "/superstar/product-list/pending" }} className=""><button className="card-footer  w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne" style={{ background: "chartreuse", color: "black" }}> Pending Product
                            </button></Link>
                            :
                            <Link to={{pathname: "/superstar/product-list/pending" }} className=""><button className="card-footer Souvenir-button  w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne"> Pending Product
                            </button></Link>

                        }
                        
                    </div>
                </div>

               

                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={Unsold} className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold Unsold">{approvedCount}</small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        {
                            location.pathname === '/superstar/product-list/approved' ?
                            <Link to={{pathname: "/superstar/product-list/approved" }} className=""><button className="card-footer w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne" style={{ background: "chartreuse", color: "black" }}> Approved Products List
                            </button></Link>
                        :
                            <Link to={{pathname: "/superstar/product-list/approved" }} className=""><button className="card-footer Souvenir-button  w-100 "
                                data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                                aria-controls="collapseOne"> Approved Products List
                            </button></Link>
                        }
                    </div>
                </div>

                <div title="Live Now" className="col-md-2 align-items-center justify-content-center Souvenir-bt ">
                    <div className="card meetupCard">
                        <div className="card-body  align-items-center">
                            <center>
                                <tr>
                                    <td className="ad-card-td">
                                        <img src={Add} className="ad-card-img-top" alt="..." />
                                    </td>
                                    <td className="ad-card-td">
                                        <small className=" fw-bold"></small>
                                    </td>
                                </tr>
                            </center>
                        </div>
                        
                        <Link to='/superstar/add-products-marketPlace' className=""><button className="card-footer Souvenir-button  w-100 "
                            data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                            aria-controls="collapseOne"> Add products
                        </button></Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SuperstarMarketPlaceNav; 